export default __webpack_public_path__ + "static/media/logo04.09ee2737.svg";